export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
export function uidI() {
  return 'ixxxxxxx-yxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const ifMoment2Date = (property: any) => (property && typeof property.toDate === 'function') ? property.toDate() : property;
export { ifMoment2Date }

const toDate = (property: any) => property && isFunction(property.toDate) ? property.toDate() : property;
export { toDate }

const isFunction = (fn: any) => typeof fn === "function";
export { isFunction }

export function enumToArray(enumme: { [x: string]: any; }) {
  return Object.keys(enumme)
    .map(key => enumme[key]);
}

export const _toReference = (fields: string[], obj: Object) => fields.reduce((acc: any, e: string) => {
  acc[e] = obj[e as keyof Object] ?? null;
  return acc;
}, {});

export const sortString = (a: any, b: any) => a.name.localeCompare(b.name);
export const localeBaseCompare = (s1: string, s2: string) => s1.localeCompare(s2, undefined, { sensitivity: 'base' });

export const setSortString = (key: string) => (a: any, b: any) => a[key].localeCompare(b[key]);
//usage const sortByName = setSortString('name');

export const setSortDate = (key: string, dir: number = 1) => (a: any, b: any) => dir * (a[key]?.getTime() ?? 0) - dir * (b[key]?.getTime() ?? 0);
//usage const sortBycreatedAt = setSortDate('createdAt', -1); (-1, desc)



export const setValidationForm = (form: any) => (key: string) => (form.get(key).touched || form.get(key).dirty) && form.get(key).invalid;
export const setValidationFormTouchedOnly = (form: any) => (key: string) => form.get(key).touched && !form.get(key).valid;
//usage const isControlValid = setValidationForm(this.form);

export const setErrorMessageForm = (form: any, validationMessages: any) => (key: string) => {
  let errorMessage = "Error";
  const control = form.get(key);
  if (validationMessages[key]) {
    validationMessages[key].some(function (errorType: any) {
      errorMessage = errorType.message;
      return control?.hasError(errorType.type)
    });
  }
  return errorMessage;
}
//usage   getErrorMessage = setErrorMessageForm(this.form, this.validationMessages);

export const trimFormStrings = (form: any): void => {
  Object.keys(form.controls).forEach(e => {
    if (typeof form.controls[e].value === 'string') {
      form.controls[e].patchValue(form.controls[e].value.trim());
    }
  });
}

export const validUrlRegExp = new RegExp('^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,})[/\\w .-]*/?', 'i');
// BEWARE!! longest validator below takes several seconds to validate strings with ( ) characters, and maybe others...
// export const validUrlRegExp = new RegExp('^(https?:\\/\\/)?' + // protocol
//   '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
//   '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
//   '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
//   '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
//   '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

export const isValidHttpUrl = (string) => !!validUrlRegExp.test(string);

export const round = (number, _decimals = 2) => Math.round((number + Number.EPSILON) * (Math.pow(10, _decimals))) / (Math.pow(10, _decimals));

// returns the decimal places of a number, with an optional rounding limit
export const decimalPlaces = (n: number, maxDecimalPlaces = undefined): number => {
  n = maxDecimalPlaces ? Number(n.toFixed(maxDecimalPlaces)) : n;
  // Make sure it is a number and use the builtin number -> string.
  var s = '' + (+n);
  // Pull out the fraction and the exponent.
  var match = /(?:\.(\d+))?(?:[eE]([+\-]?\d+))?$/.exec(s);
  // NaN or Infinity or integer.
  // We arbitrarily decide that Infinity is integral.
  if (!match) { return 0; }
  // Count the number of digits in the fraction and subtract the
  // exponent to simulate moving the decimal point left by exponent places.
  // 1.234e+2 has 1 fraction digit and '234'.length -  2 == 1
  // 1.234e-2 has 5 fraction digit and '234'.length - -2 == 5
  return Math.max(
    0,  // lower limit.
    (match[1] == '0' ? 0 : (match[1] || '').length) // fraction length
    - (Number(match[2]) || 0));  // exponent
}

















